(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.isIndexTemplate = !!document.querySelector('.template-index');
      this.header = document.querySelector('.section-header');
      this.subcategory = document.querySelector('.sticky .subcategory-navigation');
      this.announcement = document.querySelector('.announcement-bar-section');
      this.transparentHeader = this.header?.querySelector('.transparent-header');

      // this.announcementHeight = this.announcement ? this.announcement.getBoundingClientRect().height : 0;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.desktopMQ = window.matchMedia('(min-width: 1025px)');

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
      this.observeSubcategoryScroll();

      // 🔥 Desktop-only transparent header
      this.desktopMQ.addEventListener('change', this.handleTransparentHeader.bind(this));
      this.handleTransparentHeader(this.desktopMQ);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    /* =========================
     HEADER HEIGHT
  ========================== */
    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderTop() {
      // Only the index/home template gets the announcement-bar-aware
      // inline top offset. Every other page leaves `top` alone entirely,
      // so the plain CSS rules drive it with no JS interference.
      // Always sets an explicit value (never just clears it) — a
      // clear-in-one-place-set-in-another split let a stale value survive
      // when scroll events fired faster than the class state settled.
      if (!this.isIndexTemplate) return;
      if (!this.announcement) return;
      // this.header.style.top = this.header.classList.contains('shopify-section-header-hidden')
      //   ? '0px'
      //   : `${this.announcementHeight}px`;
    }

    /* =========================
     INTERSECTION OBSERVER
  ========================== */
    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });

      observer.observe(this.header);
    }

    /* =========================
     TRANSPARENT HEADER (DESKTOP ONLY)
  ========================== */
    handleTransparentHeader(e) {
      if (!this.transparentHeader) return;

      if (e.matches) {
        this.observeTransparentHeader();
      } else {
        this.transparentHeader.classList.remove('transparent-header');
        this.header.style.top = '';
      }
    }

    observeTransparentHeader() {
      if (!window.matchMedia('(min-width: 1025px)').matches) return;
      if (!this.transparentHeader) return;

      // Initial state
      if (window.scrollY <= 3) {
        this.transparentHeader.classList.add('transparent-header');
        // this.setHeaderTop();
      }

      this.onTransparentScroll = () => {
        if (document.body.classList.contains('search-open')) return;
        if (window.scrollY <= 5) {
          this.transparentHeader.classList.add('transparent-header');
          // this.setHeaderTop();
        } else {
          this.transparentHeader.classList.remove('transparent-header');
          this.header.style.top = '';
        }
      };

      window.addEventListener('scroll', this.onTransparentScroll, {
        passive: true,
      });

      if (this.announcement) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting && window.scrollY <= 5) {
              this.transparentHeader.classList.add('transparent-header');
              // this.setHeaderTop();
            } else {
              this.transparentHeader.classList.remove('transparent-header');
              this.header.style.top = '';
            }
          },
          { threshold: 0 }
        );

        observer.observe(this.announcement);
      }
    }

    /* =========================
     SCROLL LOGIC
  ========================== */
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= 5) {
        // strict near-zero check — headerBounds.top isn't reliably "true top"
        // on every device, and reset() is what re-applies the announcement
        // gap, so it must only fire genuinely at the top, not on any scroll-up
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.setHeaderTop();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderTop();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.setHeaderTop();
    }

    /* =========================
     SUBCATEGORY STICKY FIX
  ========================== */
    observeSubcategoryScroll() {
      const subcat = this.subcategory;
      const header = this.header;
      if (!subcat || !header) return;

      const subcatTop = subcat.offsetTop;

      // placeholder to prevent layout jump
      const placeholder = document.createElement('div');
      placeholder.style.height = `${subcat.offsetHeight}px`;
      subcat.parentNode.insertBefore(placeholder, subcat);

      window.addEventListener(
        'scroll',
        () => {
          // Deferred to rAF — and, critically, requested AFTER onScroll's
          // own requestAnimationFrame(hide/reveal) above (this listener
          // is registered later in connectedCallback, so it always runs
          // second on the same 'scroll' event). rAF callbacks execute in
          // the order they were requested, so by the time this runs, the
          // header's shopify-section-header-hidden class has already been
          // updated for this frame — reading it synchronously here instead
          // would race ahead of that and read last frame's stale value
          // (visible as a one-frame flash exactly when reversing direction).
          requestAnimationFrame(() => {
            const scrollY = window.scrollY;

            const isHidden = header.classList.contains('shopify-section-header-hidden');

            // 🔥 ALWAYS GET CURRENT HEADER HEIGHT
            const currentHeaderHeight = header.offsetHeight;

            if (scrollY >= subcatTop - currentHeaderHeight) {
              subcat.classList.add('is-fixed');
              // Header visible → sit right below it. Header hidden → park
              // fully above the viewport using the bar's OWN height, not a
              // percentage transform stacked on top of the positive `top`
              // above (translateY(-100%) only shifts by the element's own
              // height, so combined with top:64px it only reached ~3px —
              // still on-screen). Setting `top` itself negative uses the
              // existing `transition: top 0.3s ease` to slide smoothly.
              subcat.style.top = isHidden ? `-${subcat.offsetHeight}px` : `${currentHeaderHeight - 1}px`;
            } else {
              subcat.classList.remove('is-fixed');
              subcat.style.top = '0';
            }
          });
        },
        { passive: true }
      );
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const searchArray = ['Rings', 'Earrings', 'Necklaces', 'Bracelets', 'Mangalsutra', 'Personalized'];

    const staticPlaceholder = 'Search for ';
    let dynamicPlaceholder = '';
    let searchPlaceholderIndex = 0;
    let offset = 0;
    const len = searchArray.length;
    let forwards = true;
    let skipCount = 0;
    const skipDelay = 15;
    const speed = 100;

    const inputs = document.querySelectorAll('.field .search__input');

    function type() {
      const currentText = searchArray[searchPlaceholderIndex];

      if (forwards) {
        if (offset >= currentText.length) {
          skipCount++;
          if (skipCount === skipDelay) {
            forwards = false;
            skipCount = 0;
          }
        }
      } else {
        if (offset === 0) {
          forwards = true;
          searchPlaceholderIndex++;
          if (searchPlaceholderIndex >= len) searchPlaceholderIndex = 0;
        }
      }

      dynamicPlaceholder = currentText.substring(0, offset);

      if (skipCount === 0) {
        if (forwards) {
          offset++;
        } else {
          offset--;
        }
      }

      inputs.forEach((el) => {
        el.setAttribute('placeholder', staticPlaceholder + dynamicPlaceholder);
      });

      requestAnimationFrame(() => {
        setTimeout(type, speed);
      });
    }

    // Start typing effect
    type();
  });

  // =======================
  // 🔍 DESKTOP SEARCH OPEN ON INPUT CLICK
  // =======================
  (function () {
    'use strict';
    document.addEventListener('click', function (e) {
      const input = e.target.closest('.field.desktop');
      if (!input) return;

      e.preventDefault();
      e.stopPropagation();

      const searchWrapper = document.querySelector('details-modal.header__search');
      const searchDetails = searchWrapper?.querySelector('details');
      const summary = searchDetails?.querySelector('summary');

      if (!searchWrapper || !searchDetails || !summary) return;

      if (!searchDetails.hasAttribute('open')) {
        summary.click();
      }
    });
  })();

  // =======================
  // ✅ REMOVE search-open ONLY on Search Close
  // =======================
  // document.addEventListener('click', function (e) {
  //   const closeBtn = e.target.closest('.search-modal__close-button') || e.target.closest('button[aria-label="Close"]');

  //   if (!closeBtn) return;

  //   document.body.classList.remove('search-open', 'overflow-hidden');

  //   const searchDetails = document.querySelector('.header__search details[open]');
  //   if (searchDetails) {
  //     searchDetails.removeAttribute('open');
  //   }
  // });

  } catch(e) { console.error(e); }
})();
})();
